/** Награда и её состояние — одним словарём на витрину и админку.
 *
 * В кабинете под подарком было написано «начислена», и человек читал это
 * как «уже выдали». А это источник, не состояние: одно объясняет, откуда
 * награда взялась, другое — что с ней сейчас. Пока их писали одной строкой,
 * оба вопроса оставались без ответа.
 *
 * Состояний четыре, и они закрывают весь путь награды: ждёт → в заявке →
 * использована, либо отменена в любой момент. Отменённые не прячем: вопрос
 * «куда делась моя скидка» должен иметь ответ, а не пустое место.
 */

export type RewardState = 'waiting' | 'in_order' | 'used' | 'revoked';

export interface Reward {
  id: number;
  /** percent пересчитывает сумму, prize уходит строкой менеджеру,
      express делает доставку экспрессом бесплатно */
  kind: 'percent' | 'prize' | 'express';
  value: number | null;
  title: string;
  note: string;
  source: string;
  source_label: string;
  state: RewardState;
  /** Состояние словами — считает сервер, чтобы витрина и админка не разошлись */
  state_label: string;
  created_at: string | null;
  spent_at?: string | null;
  spent_order_id?: number | null;
  given_at?: string | null;
  revoked_at?: string | null;
}

/** Цвет состояния. Мята — живое, янтарь — ждёт руки, серое — прошлое. */
export const REWARD_TONE: Record<RewardState, { ink: string; fill: string }> = {
  waiting: { ink: 'text-gold-2', fill: 'bg-gold/15' },
  in_order: { ink: 'text-mint', fill: 'bg-mint/12' },
  used: { ink: 'text-good', fill: 'bg-good/12' },
  revoked: { ink: 'text-hint', fill: 'bg-glass-2' },
};

/** Награда ещё чего-то стоит: её можно применить или получить. */
export function isLive(reward: Reward): boolean {
  return reward.state === 'waiting' || reward.state === 'in_order';
}

/** Значок награды: процент цифрой, подарок картинкой. */
export function rewardMark(reward: Reward): string {
  if (reward.kind === 'percent') return `−${Math.round(reward.value ?? 0)}%`;
  return reward.kind === 'express' ? '🚀' : '🎁';
}
